"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Recurrence_1 = require("../Recurrence");
var TimeHhMm_1 = require("../TimeHhMm");
var WeekDayPicker_1 = require("../controls/WeekDayPicker");
var widgets_1 = require("@tableau/widgets");
var SelfServiceSchedulePane_1 = require("../SelfServiceSchedulePane");
var StartTimeEndTimeComponent_1 = require("../StartTimeEndTimeComponent");
var TimeZoneDisplay_1 = require("../controls/TimeZoneDisplay");
var typestyle_1 = require("typestyle");
var Localize_1 = require("../../../gen-src/Localize");
var DayPickerStyle = { flex: '1 2 400px', marginTop: '18px' };
var StartTimePickerStyle = { flex: '1 2 165px', marginTop: '18px' };
var EndTimePickerStyle = { flex: '1 2 165px', marginTop: '18px', marginLeft: '24px' };
var TimeZoneCssStyle = { flex: '1 2 400px', marginTop: '18px' };
var Typography = widgets_1.TabStyles.Typography;
var BentonLabelTextStyle = {
    display: 'block',
    boxSizing: 'border-box',
    position: 'relative',
    fontSize: Typography.Sizing.Tiny,
    fontWeight: 'normal',
    color: Typography.Color.Secondary,
    lineHeight: '19px'
};
var HourlyRecurrencePane = /** @class */ (function (_super) {
    __extends(HourlyRecurrencePane, _super);
    function HourlyRecurrencePane(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.weekDayChangedHandler = function (weekDays) { return _this.onWeekDaysChange(weekDays); };
        _this.startTimeChangeHandler = function (time) {
            var startTime = time.toNumber();
            var endTime = _this.props.recurrenceDetails.endTime;
            // New SSS backend requires hourly schedules to start and end on the same minute
            if (!(_this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.BridgeExtractRefresh)) {
                // For 60 min schedules the end minutes must equal the start minutes
                if (_this.props.recurrenceDetails.recurrenceMinutes === Recurrence_1.RecurrenceMinutesNumber.OneHour) {
                    var endTimeHours = Math.floor(endTime / 60);
                    var startTimeMinutes = startTime % 60;
                    endTime = endTimeHours * 60 + startTimeMinutes;
                }
                else {
                    // For all other hourly recurrences they must start and end on the hour
                    startTime = Math.round(startTime / 60) * 60;
                    endTime = Math.round(endTime / 60) * 60;
                }
            }
            // do not let endTime become less than start time by design for non Admin schedules
            if (_this.props.type !== SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.AdminSchedule && endTime < startTime) {
                endTime = startTime;
            }
            var newDetails = __assign({}, _this.props.recurrenceDetails, { startTime: startTime, endTime: endTime });
            _this.props.recurrenceDetailsChangedCallback(newDetails);
        };
        _this.endTimeChangeHandler = function (time) {
            var endTime = time.toNumber();
            var startTime = _this.props.recurrenceDetails.startTime;
            // New SSS backend requires super-hourly schedules to start and end on the same minute
            if (!(_this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.BridgeExtractRefresh)) {
                // For 60 min schedules the end minutes must equal the start minutes
                if (_this.props.recurrenceDetails.recurrenceMinutes === Recurrence_1.RecurrenceMinutesNumber.OneHour) {
                    var startTimeHours = Math.floor(startTime / 60);
                    var endTimeMinutes = endTime % 60;
                    startTime = startTimeHours * 60 + endTimeMinutes;
                }
                else {
                    // For all other hourly recurrences they must start and end on the hour
                    startTime = Math.round(startTime / 60) * 60;
                    endTime = Math.round(endTime / 60) * 60;
                }
            }
            var newDetails = __assign({}, _this.props.recurrenceDetails, { startTime: startTime, endTime: endTime });
            _this.props.recurrenceDetailsChangedCallback(newDetails);
        };
        _this.recurrenceMinutesChangeHandler = function (recurrenceMinutesId) {
            var recurrenceMinutes = _this.MinutesIDToMinutesNumber(recurrenceMinutesId);
            var startTime = _this.props.recurrenceDetails.startTime;
            var endTime = _this.props.recurrenceDetails.endTime;
            if (!(_this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.BridgeExtractRefresh) && recurrenceMinutes < 60) {
                // Sub hourly recurrence only support start/end times on the hour
                startTime = Math.round(startTime / 60) * 60;
                endTime = Math.round(endTime / 60) * 60;
            }
            var newDetails = __assign({}, _this.props.recurrenceDetails, { recurrenceMinutes: recurrenceMinutes,
                startTime: startTime,
                endTime: endTime });
            _this.props.recurrenceDetailsChangedCallback(newDetails);
        };
        _this.HourlyRecurrenceOptionsDropDown = function () {
            return (React.createElement(widgets_1.SingleSelectDropdown, { type: widgets_1.DropdownButtonType.Line, label: Localize_1.Messages.RecurrenceCaptionEvery(), value: _this.MinutesNumberToMinutesID(_this.props.recurrenceDetails.recurrenceMinutes), onChange: _this.recurrenceMinutesChangeHandler, testId: _this.props.testRecurrenceMinutesPickerId, list: _this.getHourlyRecurrenceOptions(), className: typestyle_1.style({
                    flex: '1 2 165px',
                    marginTop: '18px',
                    marginLeft: '24px',
                    marginBottom: '18px'
                }) }, _this.MinutesIdToLocalizedString(_this.MinutesNumberToMinutesID(_this.props.recurrenceDetails.recurrenceMinutes))));
        };
        // Ensure we don't get given an invalid value for start/end
        // New SSS backend requires starting and end on the hour for <60min schedules
        var isNonBridgeType = !(_this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.BridgeExtractRefresh);
        var isNonOneHourRecurrence = _this.props.recurrenceDetails.recurrenceMinutes !== Recurrence_1.RecurrenceMinutesNumber.OneHour;
        if (isNonBridgeType && isNonOneHourRecurrence) {
            var startTime = Math.round(_this.props.recurrenceDetails.startTime / 60) * 60;
            var endTime = Math.round(_this.props.recurrenceDetails.endTime / 60) * 60;
            var newDetails = __assign({}, _this.props.recurrenceDetails, { startTime: startTime, endTime: endTime });
            _this.props.recurrenceDetailsChangedCallback(newDetails);
        }
        _this.weekDays = [
            { weekDayId: Recurrence_1.RecurrenceDaysOfTheWeek.Sun, weekDayCaption: Localize_1.Messages.RecurrenceDayOfWeekSundayShort() },
            { weekDayId: Recurrence_1.RecurrenceDaysOfTheWeek.Mon, weekDayCaption: Localize_1.Messages.RecurrenceDayOfWeekMondayShort() },
            {
                weekDayId: Recurrence_1.RecurrenceDaysOfTheWeek.Tue,
                weekDayCaption: Localize_1.Messages.RecurrenceDayOfWeekTuesdayShort()
            },
            {
                weekDayId: Recurrence_1.RecurrenceDaysOfTheWeek.Wed,
                weekDayCaption: Localize_1.Messages.RecurrenceDayOfWeekWednesdayShort()
            },
            {
                weekDayId: Recurrence_1.RecurrenceDaysOfTheWeek.Thu,
                weekDayCaption: Localize_1.Messages.RecurrenceDayOfWeekThursdayShort()
            },
            { weekDayId: Recurrence_1.RecurrenceDaysOfTheWeek.Fri, weekDayCaption: Localize_1.Messages.RecurrenceDayOfWeekFridayShort() },
            {
                weekDayId: Recurrence_1.RecurrenceDaysOfTheWeek.Sat,
                weekDayCaption: Localize_1.Messages.RecurrenceDayOfWeekSaturdayShort()
            }
        ];
        return _this;
    }
    HourlyRecurrencePane.prototype.onWeekDaysChange = function (weekDays) {
        var newDetails = __assign({}, this.props.recurrenceDetails, { recurrenceDaysOfWeek: weekDays });
        this.props.recurrenceDetailsChangedCallback(newDetails);
    };
    HourlyRecurrencePane.prototype.MinutesIDToMinutesNumber = function (recurrenceMinutesId) {
        switch (recurrenceMinutesId) {
            case Recurrence_1.RecurrenceMinutes.FifteenMinutes:
                return Recurrence_1.RecurrenceMinutesNumber.FifteenMinutes;
            case Recurrence_1.RecurrenceMinutes.HalfHour:
                return Recurrence_1.RecurrenceMinutesNumber.HalfHour;
            case Recurrence_1.RecurrenceMinutes.OneHour:
                return Recurrence_1.RecurrenceMinutesNumber.OneHour;
            default:
                throw 'Hourly recurrence not supported for ' + recurrenceMinutesId;
        }
    };
    HourlyRecurrencePane.prototype.MinutesNumberToMinutesID = function (recurrenceMinutes) {
        switch (recurrenceMinutes) {
            case Recurrence_1.RecurrenceMinutesNumber.FifteenMinutes:
                return Recurrence_1.RecurrenceMinutes.FifteenMinutes;
            case Recurrence_1.RecurrenceMinutesNumber.HalfHour:
                return Recurrence_1.RecurrenceMinutes.HalfHour;
            default:
                return Recurrence_1.RecurrenceMinutes.OneHour;
        }
    };
    HourlyRecurrencePane.prototype.MinutesIdToLocalizedString = function (recurrenceMinutes) {
        switch (recurrenceMinutes) {
            case Recurrence_1.RecurrenceMinutes.FifteenMinutes:
                return Localize_1.Messages.RecurrenceMinutesFifteenMinutes();
            case Recurrence_1.RecurrenceMinutes.HalfHour:
                return Localize_1.Messages.RecurrenceMinutesHalfHour();
            case Recurrence_1.RecurrenceMinutes.OneHour:
                return Localize_1.Messages.RecurrenceMinutesHour();
            default:
                throw 'Hourly recurrence not supported for ' + recurrenceMinutes;
        }
    };
    HourlyRecurrencePane.prototype.getHourlyRecurrenceOptions = function () {
        var results = [];
        switch (this.props.type) {
            case SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.AdminSchedule:
            case SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.BridgeExtractRefresh:
                results.push({
                    value: Recurrence_1.RecurrenceMinutes.FifteenMinutes,
                    content: Localize_1.Messages.RecurrenceMinutesFifteenMinutes()
                });
                results.push({
                    value: Recurrence_1.RecurrenceMinutes.HalfHour,
                    content: Localize_1.Messages.RecurrenceMinutesHalfHour()
                });
                results.push({
                    value: Recurrence_1.RecurrenceMinutes.OneHour,
                    content: Localize_1.Messages.RecurrenceMinutesHour()
                });
                break;
            default:
                results.push({
                    value: Recurrence_1.RecurrenceMinutes.OneHour,
                    content: Localize_1.Messages.RecurrenceMinutesHour()
                });
        }
        return React.createElement(widgets_1.List, { items: results, style: { maxHeight: '300px', overflow: 'auto' } });
    };
    HourlyRecurrencePane.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(this.HourlyRecurrenceOptionsDropDown, null),
            React.createElement(React.Fragment, null,
                React.createElement(StartTimeEndTimeComponent_1.StartTimeEndTimeComponent, { startCaption: Localize_1.Messages.RecurrenceCaptionFrom(), endCaption: Localize_1.Messages.RecurrenceCaptionTo(), selectedStartValue: TimeHhMm_1.TimeHhMm.fromNumber(this.props.recurrenceDetails.startTime), selectedEndValue: TimeHhMm_1.TimeHhMm.fromNumber(this.props.recurrenceDetails.endTime), onStartTimeChange: this.startTimeChangeHandler, onEndTimeChange: this.endTimeChangeHandler, startStyle: StartTimePickerStyle, endStyle: EndTimePickerStyle, minuteInterval: this.props.recurrenceDetails.recurrenceMinutes < Recurrence_1.RecurrenceMinutesNumber.OneHour
                        ? 60
                        : this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.AdminSchedule && 15, allowOvernight: this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.Default
                        || this.props.type === SelfServiceSchedulePane_1.SelfServiceSchedulePaneType.AdminSchedule, testStartSelectId: this.props.testStartTimePickerId, testEndSelectId: this.props.testEndTimePickerId, testStartCaptionId: this.props.testStartTimePickerId, testEndCaptionId: this.props.testEndTimePickerId, testStartTimeEndTimeComponentId: this.props.testStartTimeEndTimeComponentId, type: this.props.type })),
            React.createElement("div", { style: DayPickerStyle },
                React.createElement("div", { style: BentonLabelTextStyle }, Localize_1.Messages.RecurrenceCaptionOn()),
                React.createElement(WeekDayPicker_1.WeekDayPicker, { weekDays: this.weekDays, testId: this.props.testWeekDayPickerId, selectedDayIds: this.props.recurrenceDetails.recurrenceDaysOfWeek, onSelectionChanged: this.weekDayChangedHandler })),
            React.createElement("div", { style: TimeZoneCssStyle },
                React.createElement(TimeZoneDisplay_1.TimeZoneDisplay, { timeZoneDetails: this.props.timeZoneDetails, label: Localize_1.Messages.RecurrenceTimeZone(), onClick: this.props.onTimeZoneClick }))));
    };
    return HourlyRecurrencePane;
}(React.Component));
exports.HourlyRecurrencePane = HourlyRecurrencePane;
//# sourceMappingURL=HourlyRecurrencePane.js.map